import type { MessageDescriptor } from 'react-intl';

import { createColumnDefinitionBuilder } from 'ui-components/components/react-table-wrapper/create-column-definition-builder';

import { WeightCell, WeightHeaderCell } from './weight-cells';

type CreateWeightColumnOptions = {
  accessor: string;
  headerMessage: MessageDescriptor;
};

export const createWeightColumnDefinition = ({ accessor, headerMessage }: CreateWeightColumnOptions) => {
  const HeaderCell = ({ sellerDefaultWeightUnit }: { sellerDefaultWeightUnit: string }) => (
    <WeightHeaderCell headerMessage={headerMessage} sellerDefaultWeightUnit={sellerDefaultWeightUnit} />
  );

  return createColumnDefinitionBuilder({
    accessor,
    Header: HeaderCell,
    Cell: WeightCell,
    width: 1,
    minWidth: 120,
  });
};
